// extracted by css-extract-rspack-plugin
export default {"page":"page__rDwll","pageHeader":"pageHeader__yuirH","section":"section__ondFk","field":"field__mvAv2","fieldInput":"fieldInput__DHcr1"};